import { render, staticRenderFns } from "./AdminHomeStats.vue?vue&type=template&id=221fc5ae&"
import script from "./AdminHomeStats.vue?vue&type=script&lang=js&"
export * from "./AdminHomeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports